import { ConversationQuery } from '../../../../Conversation.generated'
import { Button, LinkButton } from '../../../../../../../../../utils/UI'
import { useEventEmitter } from '../../../../../../../../../utils/EventEmitter'
import { useConversationButtonCallbackMutation } from './ExecuteButtonCallback.generated'
import {
  ConversationItemButtonType,
  ConversationItemButtonActionType,
} from '../../../../../../../../../api/types'
import { useTw } from '../../../../../../../../../utils/Styles'

type ButtonProps = {
  event: ConversationQuery['Conversation']['messages'][0]
}

const ButtonStyle: Record<ConversationItemButtonType, 'primary' | 'secondary'> =
  {
    [ConversationItemButtonType.Primary]: 'primary',
    [ConversationItemButtonType.Secondary]: 'secondary',
  }

export function Buttons({ event }: ButtonProps) {
  const tw = useTw()
  const eventEmitter = useEventEmitter()
  const [executeCallback] = useConversationButtonCallbackMutation()

  return (
    <div className={tw`space-y-2`}>
      {event.buttons.map((button, i) =>
        button.action_type === ConversationItemButtonActionType.Link ? (
          <LinkButton
            href={button.url}
            text={button.text}
            target={button.target}
            kind={ButtonStyle[button.type]}
          />
        ) : (
          <Button
            key={i}
            text={button.text}
            kind={ButtonStyle[button.type]}
            onClick={() => {
              if (
                button.action_type ===
                ConversationItemButtonActionType.WidgetEvent
              )
                eventEmitter.emit(button.event_name, button.event_payload, {
                  event,
                  button,
                })
              else if (
                button.action_type === ConversationItemButtonActionType.Callback
              )
                executeCallback({
                  variables: {
                    buttonId: button._id,
                    conversationId: event.conversationId,
                  },
                })
            }}
          />
        )
      )}
    </div>
  )
}
